import React, { useState, useEffect } from "react";
import Avvvatars from "avvvatars-react";
import { Link } from "react-router-dom";
import { AxiosError } from "axios";
import { toast } from "sonner";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CreateUEModal from "./createUEModal";
import EditUEModal from "./editUEModal";
import EditSubjectUEModal from "./editSubjectUEModal";
import { my_routes } from "../../router/all_routes";
import { Select } from "antd";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import { getAllClass } from "../../../api/pedagogicElement";
import { getAllEvaluationPeriodByLevel } from "../../../api/generalParam";
import {
  deleteSubjectUE,
  deleteUE,
  getAllUEByPeriod,
  importECU,
  importUE,
} from "../../../api/ue";
import CreateSubjectUEModal from "./createSubjectUEModal";
import InfosAlertYearDisabled from "../../../core/common/alerts/infosAlertYearDisabled";
import withPermission from "../../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";

// bouton protégée pour créer une UE
const ProtectedBtnAddUE = withPermission(
  (props: any) => (
    <button
      onClick={() => props.openModal("showCreate")}
      className="btn btn-icon btn-primary ms-auto"
      // disabled={!selectedYear?.statut}
    >
      <i className="fas fa-plus" />
    </button>
  ),
  [buildPermission(Resource.UE, Action.CREATE)],
  "masquer",
);

// bouton protégée pour modifier une UE
const ProtectedBtnUpdateUE = withPermission(
  (props: any) => (
    <li>
      <button
        onClick={() => {
          props.setEditUE(props.selectedUE.id);
          props.openModal("showEditUE");
        }} // ✅ Ouvre la modale d'édition UE en passant l'ID sélectionné
        className="dropdown-item"
        // disabled={!selectedYear?.statut}
      >
        <i className="fas fa-edit me-2" /> Modifier
      </button>
    </li>
  ),
  [buildPermission(Resource.UE, Action.UPDATE)],
  "masquer",
);

// bouton protégée pour suprimmer une UE
const ProtectedBtnDeleteUE = withPermission(
  (props: any) => (
    <li>
      <button
        className="dropdown-item"
        onClick={() => props.showConfirmationAlert(props.selectedUE)}
        // disabled={!selectedYear?.statut}
      >
        <i className="fas fa-trash-alt me-2" /> Supprimer
      </button>
    </li>
  ),
  [buildPermission(Resource.UE, Action.DELETE)],
  "masquer",
);

// bouton protégée pour créer une ECU
const ProtectedBtnAddECU = withPermission(
  (props: any) => (
    <li>
      <button
        onClick={() => props.openModal("showCreateECU")}
        // disabled={!selectedYear?.statut}
        className="dropdown-item"
      >
        <i className="fas fa-plus me-2" /> Nouvelle ECU
      </button>
    </li>
  ),
  [buildPermission(Resource.SUBJECT_UE, Action.CREATE)],
  "masquer",
);

// bouton protégée pour créer une ECU
const ProtectedBtnUpdateECU = withPermission(
  (props: any) => (
    <button
      onClick={() => {
        props.setEditSubjectUE(props.mat.id);
        props.openModal("showEditECU");
      }}
      className="dropdown-item"
    >
      {" "}
      {/* ✅ Ouvre la modale d'édition ECU avec l'ID de la matière */}
      <span>
        <i data-feather="edit" />
      </span>
      Modifier
    </button>
  ),
  [buildPermission(Resource.SUBJECT_UE, Action.UPDATE)],
  "masquer",
);

// bouton protégée pour créer une ECU
const ProtectedBtnDeleteECU = withPermission(
  (props: any) => (
    <button
      onClick={() => props.showDeleteAlert(props.mat.id)}
      className="dropdown-item"
    >
      <span>
        <i data-feather="trash-2" />
      </span>
      Supprimer
    </button>
  ),
  [buildPermission(Resource.SUBJECT_UE, Action.DELETE)],
  "masquer",
);

const UeList = () => {
  const routes = my_routes;

  // 👉 Etats pour la sélection des classes et périodes
  const [allClasses, setallClasses] = useState<any[]>([]);
  const [selectedClass, setSelectedClass] = useState<any>(null);

  // 👉 Etats pour la sélection des matières et sa liste
  const [editUE, setEditUE] = useState("");
  const [editSubjectUE, setEditSubjectUE] = useState("");

  // 👉 Etats pour la sélection des période d'evaluation et sa liste
  const [allEvaluationPeriodList, setAllEvaluationPeriodList] = useState<any[]>(
    [],
  );
  const [selectedEvaluationPeriod, setSelectedEvaluationPeriod] =
    useState<any>(null);

  // 👉 Etats pour la sélection des UE et sa liste
  const [ueList, setUeList] = useState<any[]>([]);
  const [selectedUE, setSelectedUE] = useState<any>(null);

  // 👉 Etats pour le chargement des classes, périodes et UE
  const [isLoadingClasses, setIsLoadingClasses] = useState(false);
  const [isLoadingPeriods, setIsLoadingPeriods] = useState(false);
  const [isLoadingUEs, setIsLoadingUEs] = useState(false);

  // 👉 Etats pour l'affichage et la fermeture des modal des UE, ECU
  const [modals, setModals] = useState({
    showCreate: false,
    showCreateECU: false,
    showEditUE: false,
    showEditECU: false,
  });

  const [refreshKey, setRefreshKey] = useState(0);
  const totalSemesterCredits = ueList.reduce(
    (total: number, ue: any) => total + (ue.SubjectUEs || []).reduce((sum: number, ecu: any) => sum + Number(ecu.credit || 0), 0),
    0,
  );

  // 👉 Etats pour la sélection de l'année académique en cours
  const { selectedYear } = useAcademicYear();

  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  // 👉 Définition du schéma de validation pour le formulaire avec Zod
  const createSchema = z.object({
    label: z.string().nonempty("Le libellé de l'UE est requis"),
  });

  type FormFields = z.infer<typeof createSchema>;

  const {
    formState: { errors, isSubmitting },
  } = useForm<FormFields>({
    resolver: zodResolver(createSchema),
  });

  // 👉 Affiche un SweetAlert pour confirmer la suppression d'une UE
  const showConfirmationAlert = (ue: any) => {
    MySwal.fire({
      title: "Supprimer une classe ?",
      text: `Souhaitez-vous vraiment supprimer l'UE ${ue.label} ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await deleteUE(ue?.id);
          MySwal.fire({
            title: "Unité d'Enseignement supprimée avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });

          reloadData(); //On reload la liste
        } catch (error) {
          const err = error as AxiosError<any>;
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: err.response?.data?.message || err.response?.data?.error,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // 👉 Affiche un SweetAlert pour confirmer la suppression d'une ECU
  const showDeleteAlert = (ueSubject: any) => {
    MySwal.fire({
      title: "Supprimer une ECU ?",
      text: `Souhaitez-vous vraiment supprimer l'ECU ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await deleteSubjectUE(ueSubject);
          MySwal.fire({
            title: "ECU supprimée avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });

          reloadData(); //On reload la liste
        } catch (error) {
          const err = error as AxiosError<any>;
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: err.response?.data?.message || err.response?.data?.error,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // 👉 Forcer le rechargement des données en incrémentant la clé
  const reloadData = () => setRefreshKey((prev) => prev + 1);

  /**
   * 👉 Chargement des classes disponibles pour l'année académique sélectionnée
   * - Dépend de selectedYear
   * - Charge toutes les classes et sélectionne automatiquement la première si dispo
   */
  useEffect(() => {
    // On attend que selectedYear soit défini
    if (!selectedYear?.id) return;
    setIsLoadingClasses(true);
    setSelectedEvaluationPeriod(null);
    setSelectedUE(null);

    const fetchClasses = async () => {
      try {
        const response = await getAllClass(
          selectedYear?.id,
          buildPermissionContext(Resource.UE, Action.READ),
        );
        const classes = response.data || [];

        setallClasses(classes);

        // Sélectionne la première classe automatiquement s'il y en a
        if ((classes || []).length > 0) {
          setSelectedClass(classes[0]);
        }
      } catch (error: any) {
        // console.log("erreur de chargement des classes : ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );

        // Option: reset les classes en cas d'erreur
        setallClasses([]);
      } finally {
        setIsLoadingClasses(false); // ← Toujours arrêter le chargement à la fin
      }
    };

    fetchClasses();
  }, [selectedYear]);

  /**
   * 👉 Chargement des périodes d'évaluation pour le niveau de la classe sélectionnée
   * - Dépend de selectedClass
   * - Charge toutes les périodes et sélectionne automatiquement la première si dispo
   */
  useEffect(() => {
    if (!selectedClass?.Level?.id) return;
    setIsLoadingPeriods(true);
    setSelectedUE(null);

    const fetchPeriods = async () => {
      try {
        const response = await getAllEvaluationPeriodByLevel(
          selectedClass?.Level?.id,
          buildPermissionContext(Resource.UE, Action.READ),
        );
        const periods = response.data || [];

        setAllEvaluationPeriodList(periods);

        // Sélectionne la première période automatiquement s'il y en a
        if ((periods || []).length > 0) {
          setSelectedEvaluationPeriod(periods[0]);
        }
      } catch (error: any) {
        // console.log("erreur de chargement des périodes : ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );
        // Option: reset les periodes en cas d'erreur
        setAllEvaluationPeriodList([]);
      } finally {
        setIsLoadingPeriods(false); // ← Toujours arrêter le chargement à la fin
      }
    };

    fetchPeriods();
  }, [selectedClass]);

  /**
   * 👉 Chargement des Unités d'Enseignement (UE) pour la classe et la période sélectionnées
   * - Dépend de selectedClass, selectedEvaluationPeriod et refreshKey
   * - Charge toutes les UE et sélectionne automatiquement la première si dispo
   */
  useEffect(() => {
    if (!selectedClass?.id || !selectedEvaluationPeriod?.id) return;
    setIsLoadingUEs(true);

    const prevSelectedUEId = selectedUE?.id; // 🔑 On garde l’UE actuelle

    const fetchECUs = async () => {
      try {
        const response = await getAllUEByPeriod(
          selectedClass.id,
          selectedEvaluationPeriod.id,
        );
        const ues = response.data || [];
        setUeList(ues);

        // 🔄 On essaie de retrouver l’UE qui était sélectionnée
        if (prevSelectedUEId) {
          const stillExists = ues.find((ue: any) => ue.id === prevSelectedUEId);
          if (stillExists) {
            setSelectedUE(stillExists);
            return;
          }
        }

        // Si l’UE a été supprimée, on prend la 1ère
        if (ues.length > 0) {
          setSelectedUE(ues[0]);
        } else {
          setSelectedUE(null);
        }
      } catch (error: any) {
        // console.log("erreur de chargement des ECUs : ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );

        // Option: reset les UEs en cas d'erreur
        setUeList([]);
        setSelectedUE(null);
      } finally {
        setIsLoadingUEs(false); // ← Toujours arrêter le chargement à la fin
      }
    };

    fetchECUs();
  }, [refreshKey, selectedClass, selectedEvaluationPeriod]);

  // 👉 Change handler pour le select des classes
  const handleClassChange = (selectedId: string) => {
    const selected = allClasses.find(
      (c: any) => c.id.toString() === selectedId,
    );
    if (selected) setSelectedClass(selected);
  };

  const openModal = (name: keyof typeof modals) => {
    setModals((prev) => ({ ...prev, [name]: true }));
  };

  const closeModal = (name: keyof typeof modals) => {
    setModals((prev) => ({ ...prev, [name]: false }));
  };

  const handleImportUE = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file); // Assuming file is an array of files

      toast.promise(
        importUE(formData, selectedEvaluationPeriod?.id, selectedClass?.id),
        {
          loading: "Importation en cours...",
          success: () => {
            reloadData();
            return "Importé avec succès";
          },
          error: (error: any) => {
            // console.error("Error:import UE Excel ", error);

            const messageError =
              error.response?.data?.message ||
              error.response?.data?.error ||
              error.message ||
              "Une erreur s'est produit, Réessayer plus tard";
            return (
              <div>
                <strong>{messageError}</strong>
                {error.response?.data?.errors &&
                  error.response.data.errors.map((errorItem: any) => (
                    <div>
                      Ligne {errorItem?.row}: {errorItem?.message}
                    </div>
                  ))}
              </div>
            );
          },
        },
      );
    } catch (error: any) {
      // console.error("Error:import parent Excel ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const handleImportECU = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file); // Assuming file is an array of files

      toast.promise(
        importECU(
          formData,
          selectedYear?.id,
          selectedEvaluationPeriod?.id,
          selectedClass?.id,
        ),
        {
          loading: "Importation en cours...",
          success: () => {
            reloadData();
            return "Importé avec succès";
          },
          error: (error: any) => {
            // console.error("Error:import ECU Excel ", error);

            const messageError =
              error.response?.data?.message ||
              error.response?.data?.error ||
              error.message ||
              "Une erreur s'est produit, Réessayer plus tard";
            return (
              <div>
                <strong>{messageError}</strong>
                {error.response?.data?.errors &&
                  error.response.data.errors.map((errorItem: any) => (
                    <div>
                      Ligne {errorItem?.row}: {errorItem?.message}
                    </div>
                  ))}
              </div>
            );
          },
        },
      );
    } catch (error: any) {
      // console.error("Error:import ECU Excel ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  return (
    <>
      <div className="page-wrapper notes-page-wrapper">
        <div className="content pb-4">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3 pb-3 border-bottom position-relative">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Unités d'Enseignements</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="#">Évaluation</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.subjectList}>Matières</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    UE
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center gap-2 flex-wrap">
              {/* === Sélection de la Classe avec loading spinner et fallback === */}
              <div className="mb-2">
                {isLoadingClasses ? (
                  <div className="text-center my-4">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <div className="mt-2">
                      <span className="visually-hidden">Chargement...</span>
                      <span>Chargement des classes...</span>
                    </div>
                  </div>
                ) : allClasses.length > 0 ? (
                  <Select
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toString()
                        .toLowerCase()
                        .includes(input.toString().toLowerCase())
                    }
                    size="large"
                    style={{ width: 300 }}
                    placeholder="Sélectionner une classe"
                    value={selectedClass?.id?.toString()}
                    onChange={handleClassChange}
                    options={allClasses
                      .slice()
                      .sort((a: any, b: any) => {
                        const levelCompare = a.Level.label.localeCompare(
                          b.Level.label,
                          "fr",
                          { numeric: true },
                        );
                        if (levelCompare !== 0) return levelCompare;
                        return a.label.localeCompare(b.label, "fr", {
                          numeric: true,
                        });
                      })
                      .map((classe: any) => ({
                        label: `${classe.Level.label} - ${classe.label}`,
                        value: classe.id.toString(),
                      }))}
                    className="align-items-center"
                  />
                ) : (
                  <p>Aucune Classe trouvée pour cette année.</p>
                )}
              </div>
              <div className="mb-2">
                <Select
                  size="large"
                  style={{ width: 220 }}
                  loading={isLoadingPeriods}
                  disabled={!selectedClass || isLoadingPeriods}
                  placeholder="Sélectionner un semestre"
                  value={selectedEvaluationPeriod?.id?.toString()}
                  onChange={(value) => {
                    const period = allEvaluationPeriodList.find((item: any) => item.id.toString() === value);
                    setSelectedEvaluationPeriod(period || null);
                  }}
                  options={allEvaluationPeriodList.map((period: any) => ({ value: period.id.toString(), label: period.label }))}
                />
              </div>
            </div>
            <Link
              id="toggle_btn2"
              className="notes-tog position-absolute start-0 avatar avatar-sm rounded-circle bg-primary text-white"
              to="#"
            >
              <i className="fas fa-chevron-left" />
            </Link>
          </div>
          {!selectedYear?.statut && <InfosAlertYearDisabled />}
          <div className="row">
            {/* === Liste des UE sous forme de sidebar vertical === */}
            <div className="col-xl-4 col-md-4 sidebars-right theiaStickySidebar section-bulk-widget">
              <div className="stickybar">
                <div className="border rounded-3 mt-4 bg-white p-3">
                  <div className="mb-3 pb-3 border-bottom">
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <h4 className="mb-0 d-flex align-items-center">
                        <i className="ti ti-file-text me-2" />
                        Unités d'Enseignement
                      </h4>
                      <div className="d-flex align-items-center gap-1">
                        <div className="dropdown">
                          <button className="btn btn-light btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown">
                            <i className="ti ti-file-import me-1" /> Importer
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end">
                            <li><button className="dropdown-item" onClick={() => {
                              const input = document.createElement("input"); input.type = "file"; input.accept = ".xlsx, .xls";
                              input.onchange = (e) => { const files = (e.target as HTMLInputElement).files; if (files?.[0]) handleImportUE(files[0]); }; input.click();
                            }}>Importer des UE</button></li>
                            <li><button className="dropdown-item" onClick={() => {
                              const input = document.createElement("input"); input.type = "file"; input.accept = ".xlsx, .xls";
                              input.onchange = (e) => { const files = (e.target as HTMLInputElement).files; if (files?.[0]) handleImportECU(files[0]); }; input.click();
                            }}>Importer des ECU</button></li>
                          </ul>
                        </div>
                        <ProtectedBtnAddUE openModal={openModal} />
                      </div>
                    </div>
                  </div>
                  <div className="border-bottom pb-3 ">
                    <div
                      className="nav flex-column nav-pills"
                      id="v-pills-tab"
                      role="tablist"
                      aria-orientation="vertical"
                    >
                      {ueList.length > 0 ? (
                        ueList.map((ue: any, index) => (
                          <button
                            key={ue.id || index}
                            onClick={() => setSelectedUE(ue)}
                            style={{ width: "100%", minWidth: 0 }}
                            className={`d-flex text-start align-items-center fw-semibold fs-15 nav-link mb-1 ${
                              selectedUE?.id === ue.id ? "active" : ""
                            } `}
                            id={`v-pills-${ue.id}-tab`}
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-profile"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-profile"
                            aria-selected="true"
                          >
                            <i className="ti ti-inbox me-2 flex-shrink-0" />
                            <span
                              className="flex-grow-1"
                              style={{ minWidth: 0, whiteSpace: "normal", overflowWrap: "anywhere" }}
                            >
                              {`${ue.codeUE} - ${ue.label}`}
                            </span>
                            <span className={`badge ms-2 flex-shrink-0 ${selectedUE?.id === ue.id ? "bg-white text-primary" : "bg-light text-dark"}`}>
                              {(ue.SubjectUEs || []).reduce((sum: number, ecu: any) => sum + Number(ecu.credit || 0), 0)} cr.
                            </span>
                          </button>
                        ))
                      ) : (
                        <div className="text-muted p-3 text-center">
                          <i className="ti ti-inbox mb-2 fs-2" />
                          <p className="mb-0">
                            Aucune Unité d’Enseignement pour le moment.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center rounded-2 bg-light px-3 py-2 mt-3">
                    <span className="fw-semibold">Total du semestre</span>
                    <span className="badge bg-primary">{totalSemesterCredits} crédits</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-md-8 budget-role-notes">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                >
                  <div className="row">
                    <div className="col-lg-12">
                      <div
                        className="accordion todo-accordion"
                        id="accordionExample"
                      >
                        {selectedUE ? (
                          <div className="accordion-item">
                            {/* Header de l'accordéon avec menu trois points pour gérer l'UE (ajout ECU, edit, suppression) */}
                            <div className="accordion-header" id="headingOne">
                              <div className="d-flex align-items-center justify-content-between w-100 px-3 py-2">
                                {/* Partie gauche : déclenche l’accordéon */}
                                <div
                                  className="accordion-button collapsed border-0 bg-transparent p-0 flex-grow-1 d-flex align-items-center"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseOne"
                                  aria-expanded="true"
                                  aria-controls="collapseOne"
                                  style={{ boxShadow: "none", minWidth: 0 }}
                                >
                                  <i className="ti ti-calendar-due me-2" />
                                  <h5 className="fw-semibold mb-0" style={{ minWidth: 0, whiteSpace: "normal", overflowWrap: "anywhere" }}>
                                    {selectedUE.codeUE} - {selectedUE.label}
                                  </h5>
                                  <span className="badge bg-soft-light text-dark p-1 ms-2">
                                    {selectedUE.type}
                                  </span>
                                  <span className="badge bg-primary p-1 ms-2">
                                    {(selectedUE.SubjectUEs || []).reduce((sum: number, ecu: any) => sum + Number(ecu.credit || 0), 0)} crédits
                                  </span>
                                  {/* <span className="avatar avatar-xs bg-primary rounded-circle p-1 ms-2"></span> */}
                                </div>

                                {/* Partie droite : menu trois points */}
                                <div
                                  className="dropdown"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <button
                                    className="btn btn-sm btn-light"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="fas fa-ellipsis-v" />
                                  </button>
                                  <ul className="dropdown-menu dropdown-menu-end">
                                    <ProtectedBtnAddECU openModal={openModal} />

                                    <ProtectedBtnUpdateUE
                                      openModal={openModal}
                                      setEditUE={setEditUE}
                                      selectedUE={selectedUE}
                                    />

                                    <ProtectedBtnDeleteUE
                                      showConfirmationAlert={
                                        showConfirmationAlert
                                      }
                                      selectedUE={selectedUE}
                                    />
                                  </ul>
                                </div>
                              </div>
                            </div>

                            {/* Contenu des matières (ECU) pour l'UE sélectionnée */}
                            {selectedUE.SubjectUEs?.length > 0 ? (
                              <div
                                id="collapseOne"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  {selectedUE.SubjectUEs.map(
                                    (mat: any, index: any) => (
                                      <div
                                        className="card"
                                        key={mat.id || index}
                                      >
                                        <div className="card-body p-3 pb-0">
                                          <div className="d-flex align-items-center justify-content-between flex-wrap">
                                            <div className="input-block todo-inbox-check d-flex align-items-center w-50 mb-3">
                                              <div className="form-check form-check-md me-2">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                />
                                              </div>
                                              <div className="strike-info">
                                                <h4 className="mb-1">
                                                  {mat.codeECU} -{" "}
                                                  {mat.Subject.label}
                                                </h4>
                                                <p>
                                                  Professeur :{" "}
                                                  {mat.TeacherProfil.firstname}{" "}
                                                  {mat.TeacherProfil.lastname}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="d-flex align-items-center flex-fill justify-content-between ms-4 mb-3">
                                              <div className="notes-card-body d-flex align-items-center">
                                                <p className="badge bg-outline-danger d-inline-flex align-items-center me-2 mb-0">
                                                  <i className="fas fa-circle fs-6 me-1" />{" "}
                                                  {mat.credit} Crédit
                                                </p>
                                                <p className="badge bg-outline-secondary mb-0">
                                                  Coeff {mat.coefficient}
                                                </p>
                                              </div>
                                              <div className="d-flex align-items-center">
                                                <span className="avatar avatar-md me-2">
                                                  <Avvvatars
                                                    value={`${
                                                      mat.TeacherProfil.firstname?.charAt(
                                                        0,
                                                      ) || ""
                                                    }${
                                                      mat.TeacherProfil.lastname?.charAt(
                                                        0,
                                                      ) || ""
                                                    }`}
                                                    style="character" // ou "character"
                                                  />
                                                </span>
                                                <Link
                                                  to="#"
                                                  data-bs-toggle="dropdown"
                                                  aria-expanded="false"
                                                >
                                                  <i className="fas fa-ellipsis-v" />
                                                </Link>
                                                {/* Menu trois points pour chaque ECU : Modifier ou Supprimer */}
                                                <div className="dropdown-menu notes-menu dropdown-menu-end">
                                                  <ProtectedBtnUpdateECU
                                                    openModal={openModal}
                                                    setEditSubjectUE={
                                                      setEditSubjectUE
                                                    }
                                                    mat={mat}
                                                  />

                                                  <ProtectedBtnDeleteECU
                                                    showDeleteAlert={
                                                      showDeleteAlert
                                                    }
                                                    mat={mat}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            ) : (
                              <div className="text-center text-muted p-4">
                                <i className="ti ti-book-off mb-3 fs-1" />
                                <h5>Aucune Matière trouvée</h5>
                                <p>
                                  Ajoutez des matières (ECU) à cette Unité
                                  d’Enseignement en cliquant sur le bouton + en
                                  haut.
                                </p>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="text-center text-muted p-4">
                            <i className="ti ti-inbox mb-3 fs-1" />
                            <h5>Aucune Unité d’Enseignement sélectionnée</h5>
                            <p>
                              Veuillez choisir une UE dans la liste à gauche
                              pour afficher ses matières.
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* === Modales de création/édition des UE et ECU === */}
        {/* Modal de création d'UE */}
        {selectedClass && (
          <CreateUEModal
            show={modals.showCreate}
            levelID={selectedClass?.Level?.id}
            classID={selectedClass.id}
            classLabel={selectedClass.abbreviation}
            onClose={() => closeModal("showCreate")}
            onSaved={reloadData}
          />
        )}

        {/* Modal d'édition d'UE */}
        {selectedUE && (
          <EditUEModal
            show={modals.showEditUE}
            levelID={selectedClass?.Level?.id}
            ueID={selectedUE?.id}
            onClose={() => closeModal("showEditUE")}
            onSaved={reloadData}
          />
        )}

        {/* Modal de création d'ECU (matière) */}
        {selectedUE && (
          <CreateSubjectUEModal
            show={modals.showCreateECU}
            ueID={selectedUE?.id}
            classID={selectedClass?.id}
            subjectUes={selectedUE?.SubjectUEs}
            codeUE={selectedUE?.codeUE || ""}
            onClose={() => closeModal("showCreateECU")}
            onSaved={reloadData}
          />
        )}

        {/* Modal d'édition d'ECU (matière) */}
        <EditSubjectUEModal
          show={modals.showEditECU}
          ueSubjectID={editSubjectUE}
          classID={selectedClass?.id || ""}
          onClose={() => closeModal("showEditECU")}
          onSaved={reloadData}
        />
      </div>
    </>
  );
};

export default UeList;
